import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=c7e18b5c&"
import script from "./Materials.vue?vue&type=script&lang=js&"
export * from "./Materials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e18b5c')) {
      api.createRecord('c7e18b5c', component.options)
    } else {
      api.reload('c7e18b5c', component.options)
    }
    module.hot.accept("./Materials.vue?vue&type=template&id=c7e18b5c&", function () {
      api.rerender('c7e18b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/DataView/Study/Materials.vue"
export default component.exports